






































import { updateExternalAssignments } from '@adobe/edex/frontend/api/externalAssignment';

export default {
  name: 'assignment-actions',
  props: {
    assignment: {
      default: () => {
        return {};
      },
      type: Object,
    }, 
  },
  data() {
    return {
      show: false,
      action: '',
      loading: false,
      error: false,
    };
  },
  computed: {
  },
  methods: {
    async submit() {
      const { course_id, assignment_id } = this.assignment;
      this.loading = true;
      try {
        const payload = {
          assignment_id,
          assignment_status: this.action,
        };
        const { data } = await updateExternalAssignments(payload);
        if (data) {
          this.$emit('onRowUpdated', data);
          this.action = '';
          this.error = false;
          this.show = false;
        }
      } catch (error) {
        this.$emit('onRowUpdatedError');
        this.error = true;
      }
      this.loading = false;
    },
    handleClose() {
      this.show = !this.show;
      this.action = '';
      this.loading = false;
      this.error = false;
    },
  },
};
